import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { Globals } from '../common/Globals';
import { HelperService } from '../common/helper.service';
import * as tokenDecoder from 'jwt-decode';
import { NgxUiLoaderService } from 'ngx-ui-loader';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  username: string;
  password: string;
  rememberMe: boolean = false;

  constructor(private authService: AuthService,
    private router: Router,
    private helperService: HelperService,
    private ngxService: NgxUiLoaderService) { }

  ngOnInit() {
    var getRememberMe = localStorage.getItem("rememberMe");
    this.rememberMe = getRememberMe == "true";
    if (AuthService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
    }

  }

  login() {
    if (!this.username || !this.password) {
      alert('All fields are required!');
      return;
    }
    localStorage.setItem('rememberMe', this.rememberMe.toString());
    this.ngxService.start();
    this.authService.login(this.username.trim(), this.password.trim()).subscribe((response: any) => {
      if (response.jwt.access_token) {
        const username = tokenDecoder(response.jwt.access_token)['clientName'];
        localStorage.setItem('getBoxSize', response.boxSize);
        localStorage.setItem('gesAuthToken', response.jwt.access_token);
        localStorage.setItem('gesActiveUser', username);
        localStorage.setItem('getChangeGroupTime', response.changeGroupTime);
        localStorage.setItem('getCompanyId', response.companyId);
        localStorage.setItem('bid', response.bid);
        localStorage.setItem('loginTime', new Date().toString());
        this.helperService.loggedUsername = username;
        this.router.navigate(['/dashboard']);
      } else {
        this.ngxService.stop();
        alert('Invalid login');
      }
    }, error => {
      this.ngxService.stop();
      if (error.status === 401) {
        alert('Invalid login');
      } else if (error.status === 400) {
        alert('Invalid login');
      } else {
        alert('An error has occured. Please try again later.');
      }
    });
  }

}
